import errors from './errors';
import common from './common';
import home from './home';

export default {
  errors,
  common,
  home,
};
